import BackgroundColors from '@root/joinroot.com/src/utils/background-colors';
import PropTypes from '@root/vendor/prop-types';
import { Eyebrow, H2, P1 } from '@root/joinroot.com/src/components/text';
import { StyleSheet } from '@root/core/src/utils/styles';

export default function VideoToutSection({
  anchor,
  backgroundColor = BackgroundColors.cmsValues.WHITE,
  body,
  children,
  eyebrow,
  title,
}) {
  return (
    <section
      css={[
        styles.videoToutSection,
        styles.anchorSpacer,
        BackgroundColors.getBackgroundStyle(backgroundColor),
      ]}
      id={anchor}
    >
      {(eyebrow || title || body) &&
        <div css={styles.headingContainer}>
          {eyebrow && <Eyebrow css={styles.eyebrow}>{eyebrow}</Eyebrow>}
          {title && <H2 css={styles.title}>{title}</H2>}
          {body && <P1 css={styles.body}>{body}</P1>}
        </div>
      }
      <div css={styles.childrenContainer}>
        {children}
      </div>
    </section>
  );
}

const styles = StyleSheet.create({
  videoToutSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '80px 0',
    textAlign: 'center',
  },
  anchorSpacer: {
    '&:before': {
      display: 'block',
      content: '" "',
      marginTop: -110,
      height: 110,
      visibility: 'hidden',
      pointerEvents: 'none',
    },
  },
  headingContainer: {
    maxWidth: 500,
    margin: '0 20px 50px',
  },
  eyebrow: {
    marginBottom: 15,
  },
  title: {
    marginTop: 0,
    marginBottom: 15,
  },
  childrenContainer: {
    maxWidth: 1160,
  },
});

VideoToutSection.propTypes = {
  anchor: PropTypes.string,
  backgroundColor: PropTypes.oneOf(BackgroundColors.cmsValueList),
  body: PropTypes.node,
  children: PropTypes.node.isRequired,
  eyebrow: PropTypes.node,
  title: PropTypes.node,
};
